import React, { useState, useEffect } from "react";
import Android from "../../../../../assets/images/android.svg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { setShowInfo } from "../../../AxiosRtk/successMessage";

const TodayAppActivities = ({ getLangTranslation }) => {
  const history = useHistory();
  const [totalAppUsedDuration, setTotalAppUsedDuration] = useState(0);
  const [utilityType, setUtilityType] = useState("TIME");
  const { latestActivityData, kidList, selectedKidId, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true);
  function getDurationPercentage(duration) {
    return duration ? ((duration / totalAppUsedDuration) * 100)?.toFixed(2) : 0;
  }

  function timeConverter(seconds, hmOnly = false) {
    if (!seconds) return 0;
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - hours * 3600) / 60);
    seconds = seconds - hours * 3600 - minutes * 60;

    if (hmOnly) {
      return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes
        }`;
    }

    // Add leading zero to single-digit minutes and seconds
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}h ${minutes}m ${seconds}s`;
  }

  useEffect(() => {
    if (!isEmpty(latestActivityData?.recentApps)) {
      const totalDuration = latestActivityData?.recentApps?.reduce(
        (accumulator, object) => {
          return accumulator + object?.totalDailyDuration;
        },
        0
      );
      setTotalAppUsedDuration(totalDuration);
    }
  }, [latestActivityData]);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [isDevicesAvailable]);

  const handleAppClick = (event) => {
    // If no device is selected, show an error message and prevent navigation
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; // Stop further action if device is not selected
    }

    // Proceed to the /keyword-stats page if a device is selected
    if (!isDisabled) {
      history.push("/apps-activity");
    }
  };

  return (
    <div className="col-md-6">
      <div className="card h-100">
        <div
          className="card-header d-flex justify-content-between align-items-center c-pointer"
          onClick={handleAppClick}
        >
          <h3 className="card-title mb-0">
            {getLangTranslation("CHILD_DETAIL_APP_ACTIVITY", "Apps Activity")}
          </h3>
          <i
            className={`cursor-pointer fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
              }`}
            aria-hidden="true"
          ></i>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center gap-3 mb-6">
            <h5 className="mb-0">
              {getLangTranslation("PERCENTAGE_FILTER", "Percentage (%)")}
            </h5>
            <div className="form-check form-switch">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                role="switch"
                // defaultChecked
                checked={utilityType === "PERCENTAGE_FILTER" ? false : true}
                onChange={(e) => {
                  if (utilityType === "PERCENTAGE_FILTER") {
                    setUtilityType("TIME_FILTER");
                  } else {
                    setUtilityType("PERCENTAGE_FILTER");
                  }
                }}
                disabled={!isDevicesAvailable}
                id="appsActivityCount"
              />
              <h5 className="mb-0">
                {getLangTranslation("TIME_FILTER", "Time")}
              </h5>
            </div>
          </div>

          <div className="list-wrap d-web-activity">
            {latestActivityData?.recentApps?.map((app) => {
              return (
                <div className="list-item mb-6" key={app?.ID}>
                  <div className="d-flex align-items-center">
                    <span className="icon-wrap flex-shrink-0 me-3">
                      <img
                        src={app?.image ? app?.image : Android}
                        alt="icon"
                        width={22}
                      />
                    </span>
                    <div className="flex-grow-1">
                      <p className="d-a-title d-flex justify-content-between mb-3 text-break">
                        {app?.appName}
                        {utilityType === "PERCENTAGE_FILTER" ? (
                          <span>
                            {getDurationPercentage(app?.totalDailyDuration) +
                              "%"}
                          </span>
                        ) : (
                          <span>{timeConverter(app?.totalDailyDuration)}</span>
                        )}
                      </p>
                      <div
                        className="progress"
                        role="progressbar"
                        aria-label="Basic example"
                        aria-valuenow="25"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: `${getDurationPercentage(
                              app?.totalDailyDuration
                            )}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {latestActivityData?.recentApps?.length === 0 && (
              <div className="text-center my-6">
                {getLangTranslation(
                  "PARENT_TASK_DATA_NOT_FOUND",
                  "No data found !"
                )}
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayAppActivities;
